export interface ParticipationPanelStateModel {
  gamesConfig: any[];
}
export const PARTICIPATION_PANEL_STATE: ParticipationPanelStateModel = {
  gamesConfig: [],
};
